import { Component, OnInit, EventEmitter } from '@angular/core';
import { MaterializeAction } from 'angular2-materialize';
import { ApiRequestService } from "../../../_services/api-request.service";
import { ActivatedRoute, Router } from "@angular/router";
import { saveAs } from 'file-saver';
// import * as html2pdf from 'html2pdf.js';

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

declare var $:any;
declare var Materialize:any;


@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.css']
})
export class ResultsComponent implements OnInit {

  search : string = '';
  afterResponse : any = {};
  loading = false;
  FilterDataResult;
  FilterDataError;
  FilterDataCount;
  FilterDataColumn;
  FixedColumn = ["Body Part","Treatment Requested","Clinical Summary","Decision Explanation","Decision","Date","Case.#"];


  detail_modal = new EventEmitter<string | MaterializeAction>();

  SpecificItemDetail;

  FullPDF;
  FullCSV;

  TextView;

  constructor(private apirequest : ApiRequestService, private route:ActivatedRoute , private router: Router) { }

  ngOnInit() {
    this.search = this.route.snapshot.params['searchId'];
    console.log(this.search);   
    this.verifyEmail();
  }

  verifyEmail() {
    this.loading = true;
      console.log(this.search);
      let data = {
        result_code: this.search,
        action: 'get_result'
      };
      console.log(data);
      
      this.apirequest.customize_flow(data).subscribe((res) => {
        console.log(res);
      //   res = {
      //     msg: [
      //         {
      //             "Case.#": "CM17-0227207",
      //             "Decision Date": "2017-12-22",
      //             "Result": "Uphold",
      //             "Final Determination": "maximus federal services sent the complete case file to an expert reviewer. the expert reviewer: has no affiliation with the employer, employee, providers or the claims administrator;  has been in active clinical practice for more than five years and is currently working at least  24 hours a week in active practice;  was selected based on his/her clinical experience, education, background, and expertise in the same or similar specialties that evaluate and/or treat the medical condition and disputed items/service; is familiar with governing laws and regulations; applied the mtus medical evidence search sequence and mtus methodology for evaluating medical evidence where appropriate; and has the following credentials:    state(s) of licensure: california  certification(s)/specialty: occupational medicine, preventive medicine ",
      //             "Clinical Summary": "the following clinical case summary was developed based on a review of the case file, including all medical records: the injured worker is a 70-year-old female, who sustained an industrial injury on 06-11-1999. a review of the medical records indicates that the worker is undergoing treatment for cervical radiculopathy, intervertebral disc disorders with radiculopathy of lumbosacral region, postlaminectomy syndrome, unilateral primary osteoarthritis of right hip and other bursitis of right hip. treatment has included zolpidem (since at least 04-27-2017), pain medication, acupuncture, chiropractic therapy, epidural steroid injections, massage therapy, transcutaneous electrical nerve stimulator unit and surgery. subjective complaints (10-11-2017) included shooting pain down the left arm, improved left hip pain and neck, leg and low back pain that was affecting sleep. the duration of sleep, sleep maintenance, hygiene and other measures used to maintain or promote sleep weren't documented. objective findings (10-11-2017) included tenderness to palpation of the cervical facets with trapezial spasm, tenderness of the lumbar facets with thoracolumbar spasm, antalgic gait, pain with range of motion and decreased right lower extremity motor strength. a utilization review dated 11-01-2017 non-certified a request for ambien 10mg #120.",
      //             "Determination Summary": "1. ambien 10mg #120 2. oxycontin 15mg cr #60 for rx date 10/25/2017 3. oxycodone 10mg #120 for rx date 10/25/2017 uphold ur decision not reviewed / authorized not reviewed / authorized",
      //             "Decision Explaination": "public copy for imr case number fdl – public copy v. 1.0 1 1. ambien 10mg #120 is not medically necessary and appropriate. ur evidence cited: mtus chronic pain medical treatment 2016 guidelines, section(s): zolpidem (ambien®). imr evidence cited: non-mtus official disability guidelines, pain section/zolpidem (ambien®) topic imr rationale: the 2017 mtus guidelines only address the use of ambien as it related to fibromyalgia, in which, the guidelines do not recommend the medication. per the odg, zolpidem (ambien) is a prescription short-acting non-benzodiazepine hypnotic, which is recommended for short-term (7-10 days) treatment of insomnia. proper sleep hygiene is critical to the individual with chronic pain and often is hard to obtain. various medications may provide short-term benefit. while sleeping pills, so-called minor tranquilizers, and anti-anxiety agents are commonly prescribed in chronic pain, pain specialists rarely, if ever, recommend them for long-term use. they can be habit-forming, and they may impair function and memory more than opioid pain relievers. there is also concern that they may increase pain and depression over the long-term. as the long-term use of ambien is not recommended by the guidelines, medical necessity has not been established. the request for ambien 10mg #120 is not medically necessary. 2. oxycontin 15mg cr #60 for rx date 10/25/2017 not reviewed / authorized 3. oxycodone 10mg #120 for rx date 10/25/2017 not reviewed / authorized public copy for imr case number fdl – public copy v. 1.0 2",
      //             "Body Part": "['leg', 'hip', 'cervical', 'lumbar']"
      //         }
      //     ],
      //     error_values: {
      //         "Body Part": "Head  Shoulder",
      //         "Treatment": "Vaginal moisturizers. Try a vaginal moisturizer (K-Y Liquibeads, Replens, Sliquid, others) to restore some moisture to your vaginal area. ...",
      //         "Services": "sad"
      //     },
      //     count: 1,
      //     status: "True"
      // };
        if(res.status === "True") {
          this.loading = false;
          this.FilterDataResult = res.msg;
          let col = Object.keys(res.msg[0]);
          this.FilterDataColumn = col;
          this.FullPDF = res.pdfurl;
          this.FullCSV = res.csvurl;
          // this.FilterDataError = res.error_values;
          this.FilterDataCount = res.count;
          console.log(this.FilterDataResult);          
          console.log(this.FilterDataColumn);
          // console.log(this.FilterDataError);
          console.log(this.FilterDataCount);
        } else if(res.status === "False") {
          this.loading = false;
          this.msg_view(res.msg);
          this.TextView = res.msg;
        } 
      });
  }

  DetailModalOpen(item){
    console.log(item);
    this.SpecificItemDetail = item;
    this.detail_modal.emit({action: 'modal', params: ['open']});
  }

  DetailModalClose(){
    this.detail_modal.emit({action: 'modal', params: ['close']});
  }

  msg_view(msg_data) {
    $(document).ready(function() {
      Materialize.toast(msg_data.toString(), 3000, 'grey darken-4');
    });
  }

  copy_text(){
    var range:any = document.createRange();
    range.selectNode(document.getElementById("information"));
    window.getSelection().removeAllRanges(); // clear current selection
    window.getSelection().addRange(range); // to select text
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    this.msg_view("Copy Text");
    // var val:any = "Case Number: "+this.imrdetail.case_number+"\r\n"+"\r\n"+
    //   "==================================="+"\r\n"+
    //   "Clinical Summary : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.clinical_simmary+"\r\n"+"\r\n"+
    //   "IMR Final : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.how_imr_final_determ+"\r\n"+"\r\n"+
    //   "IMR Decision Explanation : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.imr_decision_explan+"\r\n"+"\r\n"+
    //   "IMR Decision Summary : "+"\r\n"+"==================================="+"\r\n"+this.imrdetail.imr_decision_summary+"\r\n"+"\r\n";
    // let selBox = document.createElement('textarea');
    // selBox.style.position = 'fixed';
    // selBox.style.left = '0';
    // selBox.style.top = '0';
    // selBox.style.opacity = '0';
    // selBox.value = val;
    // document.body.appendChild(selBox);
    // selBox.focus();
    // selBox.select();
    // document.execCommand('copy');
    // document.body.removeChild(selBox);
  }

  download_text(){
    console.log(this.SpecificItemDetail);
    
    
    let file = new Blob([this.FixedColumn[0]+" : "+"\r\n"+"==================================="+"\r\n"+this.SpecificItemDetail[this.FixedColumn[0]]+"\r\n"+"\r\n"+"==================================="+"\r\n"+
    [this.FixedColumn[1]]+" : "+"\r\n"+"==================================="+"\r\n"+this.SpecificItemDetail[this.FixedColumn[1]]+"\r\n"+"\r\n"+
    [this.FixedColumn[2]]+" : "+"\r\n"+"==================================="+"\r\n"+this.SpecificItemDetail[this.FixedColumn[2]]+"\r\n"+"\r\n"+
    [this.FixedColumn[3]]+" : "+"\r\n"+"==================================="+"\r\n"+this.SpecificItemDetail[this.FixedColumn[3]]+"\r\n"+"\r\n"+
    [this.FixedColumn[4]]+" : "+"\r\n"+"==================================="+"\r\n"+this.SpecificItemDetail[this.FixedColumn[4]]+"\r\n"+"\r\n"+
    [this.FixedColumn[5]]+" : "+"\r\n"+"==================================="+"\r\n"+this.SpecificItemDetail[this.FixedColumn[5]]+"\r\n"+"\r\n"+
    [this.FixedColumn[6]]+" : "+"\r\n"+"==================================="+"\r\n"+this.SpecificItemDetail[this.FixedColumn[6]]+"\r\n"+"\r\n"],{ type: "plain/text;charset=utf-8" });
    saveAs(file, this.SpecificItemDetail[this.FixedColumn[6]]+'.txt');  
  }

  download_pdf(){
    console.log(this.SpecificItemDetail);
    console.log(this.FixedColumn);
  this.download_pdf2();
  }

  download_pdf2(){
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    // var dd = { content: 'This is an sample PDF printed with pdfMake' };
    // pdfMake.createPdf(dd).download();

    var docDefinition = {
      content: [
        {
            image: 'logo',
            width: 100,
            alignment: 'right',
            absolutePosition: { x: 0, y: 40 }
        },
        {
            text: this.FixedColumn[6]+":\n\n",
            style: "heading"
        },
        {
            text: this.SpecificItemDetail[this.FixedColumn[6]]+"\n\n",
            style: "caseNo"
        },
        {
            text: this.FixedColumn[0]+"\n\n",
            style: "heading"
        },
        this.SpecificItemDetail[this.FixedColumn[0]]+"\n\n",
        {
            text: this.FixedColumn[1]+"\n\n",
            style: "heading"
        },
        this.SpecificItemDetail[this.FixedColumn[1]]+"\n\n",
        {
            text: this.FixedColumn[4]+"\n\n",
            style: "heading"
        },
        this.SpecificItemDetail[this.FixedColumn[4]]+"\n\n",
        {
            text: this.FixedColumn[3]+"\n\n",
            style: "heading"
        },
        this.SpecificItemDetail[this.FixedColumn[3]]+"\n\n",
        {
            text: this.FixedColumn[2]+"\n\n",
            style: "heading"
        },
        this.SpecificItemDetail[this.FixedColumn[2]]+"\n\n",
        {
            text: this.FixedColumn[5]+"\n\n",
            style: "heading"
        },
        this.SpecificItemDetail[this.FixedColumn[5]]+"\n\n"
    ],
      styles: {
          heading: {
              fontSize: 14,
              bold: false,
              color: '#56beaf',
              characterSpacing: 2,
          },
          caseNo: {
              fontSize: 30,
              bold: true,
              color: "#56beaf"
          }
      },
      images: {
          logo: "https://www.imrservice.us/assets/imr-logo.png"
      }
  };

     pdfMake.createPdf(docDefinition).download(this.SpecificItemDetail[this.FixedColumn[6]]+'.pdf');
  }
}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/results/results.component.ts